<template></template>

<script>

    export default {
        mounted() {
            new noty({
                theme: 'bootstrap-v4',
                type: this.type,
                layout: 'topCenter',
                text: this.msg,
                
            }).show();
        },
        props: {
            type: { default: 'warning' },
            msg: {},
            timeout: { default: 1500 },

        }
    }
</script>
